const ITEMS = [
  "Bespoke Velvet Packaging",
  "Monogrammed Wax Seals",
  "Artisanal Tea Blends",
  "Custom Laser Engraving",
  "Handcrafted Leather Goods",
  "Corporate Onboarding Curations",
];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee-strip"
      className="overflow-hidden border-y border-gold/15 bg-cream-dark/70 py-5 select-none"
    >
      <div className="animate-marquee flex w-max items-center">
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif text-lg italic text-ink/70 px-8">{item}</span>
            <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold/70" />
          </span>
        ))}
      </div>
    </div>
  );
}
